/**
 * @description ФАЙЛ МУСОРКА!!!
 */

import {
    ProjectManagementAction,
    ProjectManagementGetter,
    ProjectManagementMutation,
    ProjectManagementState,
} from '@/store/ProjectManagement/ProjectManagementRoot';
import { Component, Ref, Vue } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';

// Enums
import ModalEnum from '@/ship/Enums/ModalEnum';
import {
    PMChartBpcStatusEnum,
    PMChartStatusEnum,
    PMChartTypeEnum,
    PMPlanChartEnum,
    PMTableActionEnum,
} from '@/ship/Enums/ProjectManagementEnums';

// Utils
import ErrorService from '@/utils/ErrorService';
import { downloadFile } from '@/utils/FilesDownloading';
import { fromISODateToLocalDate, tooltipForContent } from '@/utils/Helper';

// Interfaces
import PMChartHistory from '@/components/ProjectManagement/PMChartHistory.vue';
import VContextList from '@/components/VContextList.vue';
import IDictionary from '@/ship/Models/IDictionary';
import {
    IPMApprovalUsers,
    IPMChart,
    IPMChartBpc,
    IPMChartBpcRow,
    IPMChartDpc,
    IPMChartDpcExec,
    IPMChartDpcExecRow,
    IPMChartDpcRow,
    IPMChartRow,
    IPMChartVersion,
    IPMChartVersionRow,
    IPMChartWeeklyReport,
    PMChartBpcStatuses,
    PMChartStatuses,
    PMChartStatusesExtended,
} from '@/ship/Models/IProjectManagement';
import PMChartEditModel from '@/ship/Models/PMChartEditModel';
import Project from '@/ship/Models/Project';
import { ChartVersion } from '@/ship/Models/ProjectManagement';
import User from '@/ship/Models/User';
import { GetRequestParams } from '@/ship/Requests/RequestParams';
import {
    getPdfPMPlanChart,
    getPMChartDpcExecList,
    getPMChartDpcList,
    getWeeklyReportList,
} from '@/utils/api/ProjectManagement/PMChart';
import { get, omit } from 'lodash';

type TableRow = IPMChartRow | IPMChartDpcRow | IPMChartBpcRow | IPMChartDpcExecRow | IPMChartWeeklyReport;
type IPMChartType = IPMChartBpc | IPMChartDpc | IPMChartDpcExec | ChartVersion;

@Component({
    components: {},
})
export default class PMMixin extends Vue {
    @Action GET_ALL_PROJECTS!: (include: boolean) => Promise<Project[]>;
    @Action GET_USERS!: (include: boolean) => Promise<User[]>;
    @State projects!: Project[];
    @State user!: User;
    @State users!: User[];

    @ProjectManagementAction GET_CHART_BY_ID!: (params: { id: number; params?: GetRequestParams }) => Promise<IPMChart>;
    @ProjectManagementAction UPDATE_CHART_BY_ID!: (params: { id: number; data: PMChartEditModel }) => Promise<IPMChart>;
    @ProjectManagementAction GET_CHART_VERSION_BY_ID!: (id: number, isStrict?: boolean) => Promise<ChartVersion>;
    @ProjectManagementState chart!: IPMChart;
    @ProjectManagementState editChart!: IPMChart | null;
    @ProjectManagementState('users') projectManagementUsers!: User[];
    @ProjectManagementMutation SET_CHART_VERSION!: (structure: ChartVersion) => void;
    @ProjectManagementMutation ADD_CHART_VERSION!: (version: IPMChartVersion) => void;
    @ProjectManagementMutation REMOVE_CHART_VERSION_BY_ID!: (id: number) => void;
    @ProjectManagementMutation CLEAR_CHART!: () => void;
    @ProjectManagementMutation UPDATE_CHART_VERSION_BY_ID!: (version: IPMChartVersion) => void;
    @ProjectManagementGetter chartVersions!: IPMChartVersionRow[];
    @ProjectManagementGetter isStructureExist!: boolean;

    @Ref() actionsList!: VContextList;
    @Ref() documentHistory!: PMChartHistory;
    @Ref() printButton!: HTMLLinkElement;

    readonly pmChartBpcStatuses = PMChartBpcStatuses;
    readonly PMChartStatusEnum = PMChartStatusEnum;
    readonly pmChartStatuses = PMChartStatuses;
    readonly PMChartStatusesExtended = PMChartStatusesExtended;
    readonly PMTableActionEnum = PMTableActionEnum;
    readonly PMChartTypeEnum = PMChartTypeEnum;
    readonly prefix = 'page.projectManagement';
    readonly tooltipForContent = tooltipForContent;

    maxHeight = 43;

    docUsers: IPMApprovalUsers = {
        mainEngineerId: NaN,
        branchDirectorId: NaN,
        regionalHeadId: NaN,
        regionalDesigningHeadId: NaN,
        constructionDirectorDeputyId: NaN,
        designingDirectorDeputyId: NaN,
        generalDirectorDeputyId: NaN,
        designManagementCenterHeadId: NaN,
        generalDirectorId: NaN,
        projectManagerId: NaN,
        businessAnalystId: NaN,
    };

    chartName: string = '';
    childFields: string[] = ['childTasks'];
    extractedRows: IDictionary[] = [];

    showForm = false;

    activeRow: TableRow | null = null;

    bpcList: IPMChartBpc[] = [];
    dpcExecList: IPMChartDpcExec[] = [];
    dpcQuartList: IPMChartDpc[] = [];
    isLoadingChart: boolean = false;
    weeklyReportList: IPMChartWeeklyReport[] = [];

    isPrinting = true;

    get userOptions() {
        return this.users?.map(({ id, name }) => ({ id, name }));
    }

    get getBaseBpcStatus() {
        return this.bpcList.find(({ isBase }) => isBase)?.status;
    }

    get isBpcStatusApproval() {
        return this.bpcList.some(({ status }) => status === PMChartBpcStatusEnum.onApproval);
    }

    get isChartStatusCancelled(): boolean {
        return this.chart ? this.chart.status === PMChartStatusEnum.cancelled : true;
    }

    get isChartStatusCompleted(): boolean {
        return this.chart ? this.chart.status === PMChartStatusEnum.completed : true;
    }

    get isChartStatusPlanned(): boolean {
        return this.chart ? this.chart.status === PMChartStatusEnum.planned : true;
    }
    /**
     * @description check if mode is 'create'
     * @returns {boolean} if mode is 'create' - true, else ('view') - false
     */
    get isCreateMode(): boolean {
        return this.$route.meta?.mode === 'create';
    }

    get historyId() {
        const historyId = parseInt(this.$route.params.id);
        return historyId;
    }

    get actionOptions() {
        const options = [
            {
                label: this.$t(`page.projectManagement.charts.openChart`),
                value: PMTableActionEnum.open,
            },
            {
                label: this.$t(`history`),
                value: PMTableActionEnum.history,
            },
        ];
        return options;
    }

    get pageActionTitle() {
        return this.$t(`${this.prefix}.action.sendForApproval`);
    }

    get isActionDisabled() {
        return !(this.activeRow && this.activeRow.selected);
    }

    /**
     * get chart from route params
     */
    get chartId(): number {
        return this.getIdFromParams(this.$route.params.id);
    }

    get docId(): number {
        return this.getIdFromParams(this.$route.params.docId);
    }

    get activeRowName() {
        let name = '';
        if (this.activeRow) {
            name = this.activeRow.name ? `"${this.activeRow.name}"` : `(ID = ${this.activeRow.id})`;
        }
        return name;
    }

    get baseVersionId() {
        if (!this.chart) return 0;

        if (this.chart.versions?.data.length) {
            return this.chart.versions!.data.find((version) => version.isBaseVersion)!.id;
        }

        return 0;
    }

    getIdFromParams(paramsId: string | undefined): number {
        return paramsId ? parseInt(paramsId) : NaN;
    }

    extractRowData(entity: IDictionary, childFields: string[], level: number = 1): IDictionary {
        const children: IDictionary[] = [];

        for (const key of childFields) {
            const childEntities = get(entity, `${key}.data`);
            if (!Array.isArray(childEntities) || !childEntities.length) continue;
            const newLevel = level + 1;
            const extractedChildren = childEntities.map((child: IDictionary) =>
                this.extractRowData(child, this.childFields, newLevel),
            );
            children.push(...extractedChildren);
        }

        return {
            ...omit(entity, childFields),
            isOpen: true,
            level,
            children,
            selected: false,
        };
    }

    isUsersSelected<T extends IPMChartType>(chart: T, type: PMChartTypeEnum, every: boolean = true): boolean {
        let keys;

        switch (type) {
            case PMChartTypeEnum.design:
                keys = ['branchDirectorId', 'designingDirectorDeputyId', 'regionalDesigningHeadId'];
                break;
            case PMChartTypeEnum.construction:
                keys = ['mainEngineerId', 'regionalHeadId', 'branchDirectorId'];
                break;
            default:
                keys = [
                    'branchDirectorId',
                    'constructionDirectorDeputyId',
                    'mainEngineerId',
                    'regionalHeadId',
                    'generalDirectorDeputyId',
                ];
        }
        return every ? keys.every((key) => !!chart[key as keyof T]) : keys.some((key) => !!chart[key as keyof T]);
    }

    updateApprovalUsers(doc: IPMChartBpc | IPMChartDpc | IPMChartDpcExec | ChartVersion) {
        this.docUsers.branchDirectorId = doc.branchDirectorId;
        this.docUsers.constructionDirectorDeputyId = doc.constructionDirectorDeputyId;
        this.docUsers.designingDirectorDeputyId = doc.designingDirectorDeputyId;
        this.docUsers.generalDirectorDeputyId = doc.generalDirectorDeputyId;
        this.docUsers.mainEngineerId = doc.mainEngineerId;
        this.docUsers.regionalHeadId = doc.regionalHeadId;
        this.docUsers.regionalDesigningHeadId = doc.regionalDesigningHeadId;
        this.docUsers.designManagementCenterHeadId = doc.designManagementCenterHeadId;
        this.docUsers.generalDirectorId = doc.generalDirectorId;
        this.docUsers.projectManagerId = doc.projectManagerId;
        this.docUsers.businessAnalystId = doc.businessAnalystId;
    }

    updateDocUsers(document: IPMChartBpc | IPMChartDpc | IPMChartDpcExec | ChartVersion) {
        document.branchDirectorId = this.docUsers.branchDirectorId;
        document.constructionDirectorDeputyId = this.docUsers.constructionDirectorDeputyId;
        document.designingDirectorDeputyId = this.docUsers.designingDirectorDeputyId;
        document.generalDirectorDeputyId = this.docUsers.generalDirectorDeputyId;
        document.mainEngineerId = this.docUsers.mainEngineerId;
        document.regionalHeadId = this.docUsers.regionalHeadId;
        document.regionalDesigningHeadId = this.docUsers.regionalDesigningHeadId;
        document.designManagementCenterHeadId = this.docUsers.designManagementCenterHeadId;
        document.generalDirectorId = this.docUsers.generalDirectorId;
        document.projectManagerId = this.docUsers.projectManagerId;
        document.businessAnalystId = this.docUsers.businessAnalystId;
    }

    getUser(id?: number): User | undefined {
        if (this.users) {
            const user = this.users.find((user) => user.id === id);
            return user;
        }

        return undefined;
    }

    getProject(id?: number): Project | undefined {
        if (this.projects) return this.projects.find((project) => project.id === id);

        return undefined;
    }

    toggleShowForm() {
        this.showForm = !this.showForm;
    }

    showSuccessModal(title: string, label = this.$t('great')) {
        this.$modal.show(ModalEnum.Success, { title, label });
    }

    async loadUsers() {
        await this.GET_USERS(false);
    }

    async resetChart() {
        this.CLEAR_CHART();
        await this.loadChart();
    }

    async loadProjects() {
        if (!this.projects || !this.projects.length) {
            await this.GET_ALL_PROJECTS(false);
        }
    }

    /**
     * The `loadChart` function asynchronously loads a chart by its ID and sets the chart name if
     * successful, handling any errors that may occur.
     * @returns If the `chartId` is not defined, the function will return early and not execute the rest of
     * the code inside the function.
     */
    async loadChart() {
        if (!this.chartId) return;
        const params: GetRequestParams = {
            include: 'versions',
        };

        try {
            const chart = await this.GET_CHART_BY_ID({ id: this.chartId, params });
            this.chartName = chart.name!;
        } catch (error) {
            ErrorService.handleApiError(error);
        }
    }

    /**
     *
     * @returns
     */
    async loadChartVersion() {
        if (!this.baseVersionId) return;

        try {
            await this.GET_CHART_VERSION_BY_ID(this.baseVersionId, false);
        } catch (error) {
            ErrorService.handleApiError(error);
        }
    }

    /**
     * @description Loads the DPC chart rows based on the provided chart ID.
     */
    async loadChartDpcRows() {
        this.isLoadingChart = true;

        try {
            const response = await getPMChartDpcList(this.chart.id);
            const dpcQuartList = response.data.data;
            this.dpcQuartList = dpcQuartList;
        } catch (error) {
            ErrorService.handleApiError(error);
        } finally {
            this.isLoadingChart = false;
        }
    }

    /**
     * @description Loads the DPC Exec chart rows based on the provided chart ID.
     */
    async loadChartDpcExecRows() {
        this.isLoadingChart = true;

        try {
            const response = await getPMChartDpcExecList(this.chart.id);
            const dpcExecList = response.data.data;
            this.dpcExecList = dpcExecList;
        } catch (error) {
            ErrorService.handleApiError(error);
        } finally {
            this.isLoadingChart = false;
        }
    }

    /**
     * @description Loads the weekly report chart rows based on the provided chart ID.
     */
    async loadChartWeeklyReportRows() {
        this.isLoadingChart = true;

        try {
            const response = await getWeeklyReportList(this.chart.id);
            const weeklyReportList = response.data.data;
            this.weeklyReportList = weeklyReportList;
        } catch (error) {
            ErrorService.handleApiError(error);
        } finally {
            this.isLoadingChart = false;
        }
    }

    getCells(row: IDictionary, columns: IDictionary[]) {
        const cells: IDictionary[] = [];

        for (const column of columns) {
            const cell = {
                data: row[column.key],
                type: column.type,
                key: column.key,
            };
            cells.push(cell);
        }

        return cells;
    }

    isUser(cell: IDictionary) {
        return cell.type === 'user';
    }

    isDate(cell: IDictionary) {
        return cell.type === 'date';
    }

    isBoolean(cell: IDictionary) {
        return cell.type === 'boolean';
    }

    isStatus(cell: IDictionary) {
        return cell.type === 'status';
    }

    isCheckbox(cell: IDictionary) {
        return cell.type === 'checkbox';
    }

    isFirst(cell: IDictionary) {
        return cell.type === 'first';
    }

    isIcon(cell: IDictionary) {
        return cell.type === 'icon';
    }

    showDate(cell: IDictionary) {
        return fromISODateToLocalDate(cell.data);
    }

    showBoolean(cell: IDictionary) {
        return cell.data ? 'Да' : '-';
    }

    async downloadPlanChart(id: number, type: PMPlanChartEnum, name?: string) {
        let title = '';
        let url = `/project-management/${type as string}/${id}/excel`;

        switch (type) {
            case PMPlanChartEnum.version:
                title = this.$t(`page.projectManagement.chart.bpc.title`) as string;
                break;
            case PMPlanChartEnum.dpcQuart:
                title = this.$t(`page.projectManagement.chart.dpcQuart.title`) as string;
                break;

            case PMPlanChartEnum.dpcExec:
                title = this.$t(`page.projectManagement.chart.dpcExec.title`) as string;
                break;

            case PMPlanChartEnum.weekly:
                title = this.$t(`page.projectManagement.chart.weeklyReport.title`) as string;
                url = `/project-management/charts/weekly-report/${id}/excel`;
                break;
        }

        try {
            let fileName = title;
            fileName += name ? `- ${name}` : '';
            fileName += `- ${id}.xlsx`;
            const fileData = {
                url,
                name: fileName,
            };

            await downloadFile(fileData);
        } catch (error) {
            ErrorService.handleApiError(error);
        }
    }

    /**
     * Запрос на получение печатной формы и ее открытие
     * @param {number} id - идентификатор
     */
    async printPlanChart(id: number, type: PMPlanChartEnum) {
        if (this.isPrinting) {
            this.isPrinting = false;
            await getPdfPMPlanChart(id, type as string).then((form) => {
                this.printButton.href = form.data.toString();
                this.printButton.click();
                this.isPrinting = true;
            });
        }
    }

    showDeleteSuccessModal() {
        const title = this.$t(`${this.prefix}.chart.didDelete`, [this.activeRowName]);
        const actionLabel = this.$t('good');

        this.$modal.show(ModalEnum.Alert, { title, actionLabel });
    }
}
